import { Column } from '../../../coaching-observation/experimental.grid';
import {
    ColumnContext,
    ColumnType,
    compare,
    RosterItem,
    TemplateID,
} from '../coaching-coverage-grid.model';
import { DateRange } from '../select-period-date-range.component';

export function makeColumns(
    roster: RosterItem[],
    periodDateRanges: DateRange[],
): Array<Column<ColumnContext>> {
    const width = 300;
    const height = 45;

    const columns: Array<Column<ColumnContext>> = [
        {
            id: ColumnType.NAME.toString(),
            width,
            height,
            // TODO fix grid to handle rowSpan with or without sticky being set
            // children: [{id: 'dummy1', width, height, ctx: {type: ColumnType.DUMMY, templateId: TemplateID.HEADER}}],
            compareFn: compare,
            sticky: 'left',
            rowSpan: 2,
            cellSpan: 2,
            ctx: { type: ColumnType.NAME, templateId: TemplateID.HEADER },
        },
        {
            id: ColumnType.OA_SCORE.toString(),
            width,
            height,
            compareFn: compare,
            sticky: 'left',
            rowSpan: 2,
            ctx: { type: ColumnType.OA_SCORE, templateId: TemplateID.HEADER },
        },
        {
            id: 'dummy',
            /* TODO fix grid to handle rowSpan and use parent width
               i.e. exclude columns 'hidden' by rowSpan from column
               width calculation on the column where rowSpan is set */
            // width,
            children: [
                {
                    id: ColumnType.OVERALL_COACHING_PERCENT.toString(), // yes 'cause body cells will be tied to this child column
                    width,
                    height,
                    compareFn: compare,
                    ctx: {
                        type: ColumnType.OVERALL_COACHING_PERCENT,
                        templateId: TemplateID.HEADER,
                    },
                },
            ],
            rowSpan: 2,
            ctx: {
                type: ColumnType.OVERALL_COACHING_PERCENT,
                templateId: TemplateID.HEADER,
            },
        },
    ];

    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    periodDateRanges &&
        periodDateRanges.forEach((week, ii) => {
            columns.push({
                id: `${ColumnType.PERIOD}-${ii}`,
                children: [
                    {
                        id: `${ColumnType.COACHING_COVERAGE_PERCENT}-${ii}`,
                        width,
                        height,
                        compareFn: compare,
                        ctx: {
                            type: ColumnType.COACHING_COVERAGE_PERCENT,
                            templateId: TemplateID.HEADER,
                            week,
                        },
                    },
                    {
                        id: `${ColumnType.OBSERVATION_COVERAGE_PERCENT}-${ii}`,
                        width,
                        height,
                        compareFn: compare,
                        ctx: {
                            type: ColumnType.OBSERVATION_COVERAGE_PERCENT,
                            templateId: TemplateID.HEADER,
                            week,
                        },
                    },
                    {
                        id: `${ColumnType.COMMITMENT_COVERAGE_PERCENT}-${ii}`,
                        width,
                        height,
                        compareFn: compare,
                        ctx: {
                            type: ColumnType.COMMITMENT_COVERAGE_PERCENT,
                            templateId: TemplateID.HEADER,
                            week,
                        },
                    },
                ],
                ctx: {
                    type: ColumnType.PERIOD,
                    templateId: TemplateID.HEADER,
                    week,
                },
            });
        });

    return columns;
}
